var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 200.126,
    y: 217.817,
    className: "st0",
    width: 210.525,
    height: 53.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.126,
    y: 310.345,
    className: "st0",
    width: 48.59,
    height: 24.599
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.07,
    y: 310.345,
    className: "st0",
    width: 48.582,
    height: 24.599
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.098,
    y: 310.345,
    className: "st0",
    width: 48.589,
    height: 24.599
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.126,
    y: 361.359,
    className: "st0",
    width: 48.59,
    height: 24.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.07,
    y: 361.359,
    className: "st0",
    width: 48.582,
    height: 24.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.098,
    y: 361.359,
    className: "st0",
    width: 48.589,
    height: 24.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.126,
    y: 412.36,
    className: "st0",
    width: 48.59,
    height: 24.614
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.07,
    y: 412.36,
    className: "st0",
    width: 48.582,
    height: 24.614
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.098,
    y: 412.36,
    className: "st0",
    width: 48.589,
    height: 24.614
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M419.372,98.972h-6.518V0H198.073v98.972h-25.582h-53.516h-37.36c-42.272,0-76.663,34.391-76.663,76.663 v259.702C4.952,477.608,39.343,512,81.615,512h37.36h53.516h246.88c48.344,0,87.676-39.332,87.676-87.676v-237.67 C507.048,138.304,467.716,98.972,419.372,98.972z M220.931,22.858h169.064v137.15H220.931V22.858z M134.394,473.903H81.615 c-21.303,0-38.566-17.255-38.566-38.566V175.635c0-21.311,17.263-38.566,38.566-38.566h52.778V473.903z M468.951,424.324 c0,27.382-22.189,49.578-49.579,49.578H157.073V137.069h41v45.798h214.781v-11.429v-34.369h6.518 c27.39,0,49.579,22.189,49.579,49.586V424.324z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.599,
    y: 51.432,
    className: "st0",
    width: 117.968,
    height: 15.239
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.599,
    y: 93.338,
    className: "st0",
    width: 70.346,
    height: 15.239
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFax);
export default __webpack_public_path__ + "static/media/fax.1f243e98e707e49e8fe569ec17b51c3d.svg";
export { ForwardRef as ReactComponent };